module.exports = __webpack_public_path__ + "img/highlights2-s.3627cf2d.png";